import React from 'react';
import './Footer.scss';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <p>Designed and Developed by Asaf Lopez 2025</p>
        </div>
        <div className="footer-right">
          <p>Jesus is King <span className="cross-symbol">✝</span></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
